/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect, useState} from 'react';
import {AiOutlineWarning} from 'react-icons/ai';
import {NavbarButton, PowerInput, Radio, InputCheckbox, ChangeSelected} from '..';
import {Utils} from '../../utils/api';
import {PlayersTable, DynamicRow, TableColumnWrapper, AlertIconWrapper, AlertTextWrapper} from './styles';

export default ({
  teamMemo,
  errorData,
  handleDelete,
  handleDeleteSelected,
  dataTableContent,
  updateTableContent,
}: {
  handleDelete: any;
  handleDeleteSelected: any;
  teamMemo: Array<any>;
  updateTableContent: any;
  errorData: Array<string>;
  dataTableContent: Array<any>;
}) => {
  const [warning, useWarning] = useState({name: [], mail: [], last: [], correo: []});
  const [selected, useSelected] = useState(Array<any>());
  const [sponsor, useSponsor] = useState<any>({one: false, two: true});
  const [team, useTeam] = useState<any>([]);
  const UTILS = new Utils();

  useEffect(() => {
    returnDuplex(dataTableContent).then(el => {
      returnBadName(dataTableContent, el).then(il => {
        returnBadLast(dataTableContent, il).then(ol => {
          returnBadEmail(dataTableContent, ol).then(ul => useWarning(ul));
        });
      });
    });
    useSelected(selected.filter(selected => dataTableContent.includes(selected)));
  }, [dataTableContent]);
  useEffect(() => {
    infoChange(team, sponsor);
  }, [team]);

  function returnDuplex(content: Array<any>): Promise<any> {
    let memory: any = {};
    content.map(el => {
      try {
        memory[`${el[2]}`] = {mail: el[2], counter: memory[`${el[2]}`].counter + 1};
      } catch {
        Object.defineProperty(memory, `${el[2]}`, {
          value: {mail: el[2], counter: 0},
          writable: true,
          configurable: true,
          enumerable: true,
        });
      }
      return el;
    });
    const mailResolve = {mail: Object.values(memory).filter((el: any) => el.counter > 0)};

    return new Promise(resolve => {
      resolve(mailResolve);
    });
  }

  function returnBadName(content: Array<any>, prev: Array<any>): Promise<any> {
    let memory = {};
    const inputPattern = UTILS.GetValidationInputPattern();

    content.map(el => {
      if (!inputPattern.test(el[0])) {
        try {
          memory[`${el[0]}`] = {name: el[0], counter: memory[`${el[0]}`].counter + 1};
        } catch {
          Object.defineProperty(memory, `${el[0]}`, {
            value: {name: el[0], counter: 0},
            writable: true,
            configurable: true,
            enumerable: true,
          });
        }
      }
      return el;
    });
    return new Promise(resolve => {
      resolve({...prev, name: Object.values(memory)});
    });
  }

  function returnBadLast(content: Array<any>, prev: Array<any>): Promise<any> {
    let memory = {};
    const inputPattern = UTILS.GetValidationInputPattern();

    content.map(el => {
      if (!inputPattern.test(el[1])) {
        try {
          memory[`${el[1]}`] = {last: el[1], counter: memory[`${el[1]}`].counter + 1};
        } catch {
          Object.defineProperty(memory, `${el[1]}`, {
            value: {last: el[1], counter: 0},
            writable: true,
            configurable: true,
            enumerable: true,
          });
        }
      }
      return el;
    });
    return new Promise(resolve => {
      resolve({...prev, last: Object.values(memory)});
    });
  }

  function returnBadEmail(content: Array<any>, prev: Array<any>): Promise<any> {
    let memory = {};
    const emailPattern = UTILS.GetValidationEmailPattern();

    content.map(el => {
      if (!emailPattern.test(el[2])) {
        try {
          memory[`${el[2]}`] = {correo: el[2], counter: memory[`${el[2]}`].counter + 1};
        } catch {
          Object.defineProperty(memory, `${el[2]}`, {
            value: {correo: el[2], counter: 0},
            writable: true,
            configurable: true,
            enumerable: true,
          });
        }
      }
      return el;
    });

    return new Promise(resolve => {
      resolve({...prev, correo: Object.values(memory)});
    });
  }
  function addToSelected(selectedPlayer: any) {
    useSelected(prev => {
      if (!Boolean(prev.filter(el => selectedPlayer[2] === el[2]).length)) {
        return [...prev, selectedPlayer];
      } else {
        const unselect = prev.filter(el => selectedPlayer[2] !== el[2]);
        return [...unselect];
      }
    });
  }
  function AddTeam(selectedTeam: any): void {
    useTeam(prev => {
      if (Boolean(prev.filter(el => el.badge === 'ALL').length)) {
        const modTeams = [...prev];
        return modTeams;
      } else if (Boolean(prev.length) && selectedTeam.badge === 'ALL') {
        const modTeams = [...prev];
        return modTeams;
      } else if (!Boolean(prev.filter(el => selectedTeam._id === el._id).length)) {
        const modTeams = [...prev, selectedTeam];
        return modTeams;
      } else {
        const modTeams = [...prev];
        return modTeams;
      }
    });
  }

  function HandleRadiosSponsor(e: any): void {
    if (e.target.id.includes('player')) {
      useSponsor({one: true, two: false});
      infoChange('', {one: true, two: false});
    } else {
      useSponsor({one: false, two: true});
      infoChange('', {one: false, two: true});
    }
  }
  function selectAll() {
    selected.map(selected => addToSelected(selected));
    dataTableContent.map(select => addToSelected(select));
    if (selected.length === dataTableContent.length) {
      dataTableContent.map(select => addToSelected(select));
    }
  }

  function infoChange(iTeam: any = [], iSponsor: any = {one: false, two: true}) {
    if (iTeam) {
      updateTableContent(prev => [
        ...prev.map((el, id) => {
          el[3] = iTeam.map(team => (team = team._id));
          return el;
        }),
      ]);
    }

    if (iSponsor) {
      updateTableContent(prev => [
        ...prev.map((el, id) => {
          el[4] = iSponsor;
          return el;
        }),
      ]);
    }
  }

  function handleCancelBadge(element) {
    useTeam([...team.filter(el => element._id !== el._id)]);
  }

  return (
    <>
      <ChangeSelected
        selected={selected}
        team={team}
        ChangeTeam={AddTeam}
        teamMemo={teamMemo}
        HandleRadiosSponsor={HandleRadiosSponsor}
        sponsor={sponsor}
        handleDeleteSelected={handleDeleteSelected}
        handleCancelBadge={handleCancelBadge}
        type={'coach'}
        selectAll={() => selectAll()}
      />

      <PlayersTable>
        <thead>
          <tr>
            <th colSpan={3}>SPREADSHEET INFORMATION</th>
          </tr>
          <tr>
            <th>
              <div style={{marginLeft: '3px'}}>
                <InputCheckbox icon={'line'} onClick={() => selectAll()} checked={selected.length === dataTableContent.length} />
                <span>FIRST NAME</span>
              </div>
            </th>
            <th>
              <div>
                <span>LAST NAME</span>
              </div>
            </th>
            <th>EMAIL</th>
            <th>TEAM</th>
            <th colSpan={2}>ROLE</th>
          </tr>
        </thead>
        <tbody className="table-player-exam">
          {dataTableContent.map((item, index) => (
            <TableItem
              key={index}
              item={item}
              index={index}
              warnings={warning}
              teamMemo={teamMemo}
              errorData={errorData}
              handleDelete={handleDelete}
              updateTableContent={updateTableContent}
              addToSelected={addToSelected}
              selected={selected}
              SelectedsTeam={team}
              SelectedSponsor={sponsor}
            />
          ))}
        </tbody>
      </PlayersTable>
    </>
  );
};

const TableItem = ({
  teamMemo,
  item,
  index,
  handleDelete,
  updateTableContent,
  errorData,
  warnings,
  addToSelected,
  selected,
  SelectedsTeam,
  SelectedSponsor,
}) => {
  const [sponsor, useSponsor] = useState<any>({one: false, two: true});
  const [team, useTeam] = useState<any>([]);

  useEffect(() => {
    infoChange(team, sponsor);
  }, [team]);
  useEffect(() => {
    if (checked()) {
      return;
    } else {
      infoChange(team, sponsor);
    }
  }, [checked()]);

  function AddTeam(selectedTeam: any): void {
    if (checked()) {
      return;
    } else {
      useTeam(prev => {
        if (!Boolean(prev.filter(el => selectedTeam._id === el._id).length)) {
          return [...prev, selectedTeam];
        } else {
          return [...prev];
        }
      });
    }
  }

  function HandleRadiosSponsor(e: any): void {
    if (checked()) {
      return;
    } else {
      if (e.target.id.includes('player')) {
        useSponsor({one: true, two: false});
        infoChange('', {one: true, two: false});
      } else {
        useSponsor({one: false, two: true});
        infoChange('', {one: false, two: true});
      }
    }
  }
  function infoChange(iTeam: any = [], iSponsor: any = {one: false, two: true}) {
    if (iTeam) {
      updateTableContent(prev => [
        ...prev.map((el, id) => {
          if (id !== index) {
            return el;
          } else {
            el[3] = iTeam.map(team => (team = team._id));
            return el;
          }
        }),
      ]);
    }

    if (iSponsor) {
      updateTableContent(prev => [
        ...prev.map((el, id) => {
          if (id !== index) {
            return el;
          } else {
            el[4] = iSponsor;
            return el;
          }
        }),
      ]);
    }
  }

  function handleCancelBadge(element) {
    if (checked()) {
      return;
    } else {
      useTeam([...team.filter(el => element._id !== el._id)]);
    }
  }
  function add() {
    addToSelected(item);
  }
  function checked() {
    return selected.includes(item);
  }

  return (
    <DynamicRow checked={checked()}>
      <td>
        {Boolean(warnings.name.filter(il => il.name === item[0])[0]) ? (
          <TableColumnWrapper>
            <InputCheckbox onClick={() => add()} checked={checked()} />

            <AlertTextWrapper>{item[0]}</AlertTextWrapper>
            <AlertIconWrapper>
              <AiOutlineWarning size="20px" />
            </AlertIconWrapper>
          </TableColumnWrapper>
        ) : (
          <TableColumnWrapper>
            <InputCheckbox onClick={() => add()} checked={checked()} />
            <span>{item[0]}</span>
          </TableColumnWrapper>
        )}
      </td>
      <td>
        {Boolean(warnings.last.filter(il => il.last === item[1])[0]) ? (
          <TableColumnWrapper>
            <AlertTextWrapper>{item[1]}</AlertTextWrapper>
            <AlertIconWrapper>
              <AiOutlineWarning size="20px" />
            </AlertIconWrapper>
          </TableColumnWrapper>
        ) : (
          <TableColumnWrapper>
            <span>{item[1]}</span>
          </TableColumnWrapper>
        )}
      </td>
      <td>
        {Boolean(errorData.filter(il => il === item[2])[0]) ||
        Boolean(warnings.correo.filter(il => il.correo === item[2])[0]) ||
        Boolean(warnings.mail.filter(il => il.mail === item[2])[0]) ? (
          <TableColumnWrapper>
            <AlertTextWrapper>{item[2]}</AlertTextWrapper>
            <AlertIconWrapper>
              <AiOutlineWarning size="20px" />
            </AlertIconWrapper>
          </TableColumnWrapper>
        ) : (
          <TableColumnWrapper>
            <span>{item[2]}</span>
          </TableColumnWrapper>
        )}
      </td>
      <td>
        <TableColumnWrapper>
          <div style={{minWidth: '-webkit-fill-available'}}>
            <PowerInput
              search={true}
              onClick={AddTeam}
              dataArray={Boolean(team.length) ? teamMemo.filter(el => el.badge !== 'ALL') : teamMemo}
              selectedTeams={checked() ? SelectedsTeam : team}
              handleCancel={handleCancelBadge}
              maxWidth="800px"
            />
          </div>
        </TableColumnWrapper>
      </td>
      <td onChange={HandleRadiosSponsor}>
        <div style={{display: 'inline-flex', justifyContent: 'space-evenly', padding: '2.5px 2.5px 2.5px 2.5px', width: '95%'}}>
          <Radio
            title="Admin"
            name="formInfo"
            id={`player`}
            checked={sponsor.one}
            dynamicActive={checked() ? SelectedSponsor.one : sponsor.one}
          />
          <Radio
            title="Coach"
            name="formInfo"
            id={`sponsored`}
            checked={sponsor.two}
            dynamicActive={checked() ? SelectedSponsor.two : sponsor.two}
          />

          <NavbarButton title="X" icon="trash" onClick={() => handleDelete({element: item, index})} />
        </div>
      </td>
    </DynamicRow>
  );
};
